import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import { getReturnLabel } from '../../../commandsActions';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

/**
 * @description Générattion des étiquettes de retour
 */
const GenerateReturnLabelButton = ({
  commandId,
  dispatchGetReturnLabel,
  currentCommand
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchReturnLabel = () => {
    dispatchGetReturnLabel(commandId);
    handleClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          id="alert-dialog-slide-title"
          style={{ textAlign: 'center' }}
        >
          Attention !
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            style={{ textAlign: 'center' }}
          >
            Vous vous apprêtez à générer une étiquette retour sans créer de bon
            de retour.
            <br />
            Il nous sera impossible à la réception du retour de vérifier le
            contenu du colis et ce retour ne sera pas pris en compte dans les
            statistiques. De plus, aucun échange ne pourra être créé pour cette
            commande.
            <br />
            Êtes-vous sûr de vouloir continuer ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={() => fetchReturnLabel()} color="primary">
            Valider
          </Button>
        </DialogActions>
      </Dialog>
      {currentCommand.returnLabelUrl ? (
        <Button
          variant="contained"
          color="primary"
          href={currentCommand.returnLabelUrl}
          target="_blank"
        >
          Voir l&lsquo;étiquette retour
        </Button>
      ) : (
        <Button variant="contained" color="primary" onClick={handleClickOpen}>
          Générer l&lsquo;étiquette retour
        </Button>
      )}
    </div>
  );
};

GenerateReturnLabelButton.propTypes = {
  currentCommand: PropTypes.object,
  commandId: PropTypes.number,
  dispatchGetReturnLabel: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  dispatchGetReturnLabel: commandId => dispatch(getReturnLabel(commandId))
});

const mapStateToProps = state => ({
  currentCommand: state.commands.currentCommand
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateReturnLabelButton);
